






































































































































































































































































import { Vue, Component,Watch } from 'vue-property-decorator';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import { enums } from '@/common/enums';
import { formRules } from '@/common/util/validator';
import { ReceivableApi,ExpenseType,yun,CustomerBase } from '@/http';
import publicFunc from '../../common/util/publicFunc';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        DataPanel,
        SearchPanel,
        PaginationPanel,
        DraggerImg,
        collapse,
        ListFilterPanel,
    },
})
export default class ReceivableManagement extends Vue {
    public publicFunc=publicFunc;
    public searchValue: ReceivableApi.GetReceivableListPayload = {
        status: '',
        carrierOrderCode: '',
        subOrderNo: '',
        shipOrderNo: '',
        originShipOrderNo: '',
        deliveryOrderNo: '',
        customerBaseName: '',
        customerBaseId:'',
        carrierName: '',
        startDeliveryTime: '',
        endDeliveryTime: '',
        expenseType: '',
        asc:true,
        orderBy:''
    };
    public $refs!: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        draggerImg: HTMLFormElement;
        editForm: HTMLFormElement;
    };
    public dialogVisible: boolean = false;


    public formRules = formRules;

    public receivableStateType = enums.receivableState;
    receivableStateTypeList = ['待对账','对账中','已对账']

    public isActive: boolean = false;

    public loading: boolean = false;

    public rePagin: boolean = false;

    public total: number = 0;

    public tableData:Array<ReceivableApi.ReceivableListItemVM> = [];

    /**
     * 编辑费用
     */
    public editForm: ReceivableApi.EditReceivableVM = {
        expenseType: '',
        amount: null,
        expenseExplain: ''
    };

    public id: string = '';

    /**
     * 获取费用类型
     */
    public feeTypeList = [];
    public timeList = [];
    public created() {}
    public mounted() {
        this.GetfeeTypeList();
        if (sessionStorage.getItem('ReceivableManagement_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('ReceivableManagement_searchValue'));
            this.timeList = [this.searchValue.startDeliveryTime, this.searchValue.endDeliveryTime];
            this.searchPagin = sessionStorage.getItem('ReceivableManagement_page')
                ? JSON.parse(sessionStorage.getItem('ReceivableManagement_page'))
                : this.searchPagin;

            this.loadData();
        } else {
            this.searchPagin = sessionStorage.getItem('ReceivableManagement_page')
                ? JSON.parse(sessionStorage.getItem('ReceivableManagement_page'))
                : this.searchPagin;

            this.loadData();
        }
    }
    public colData = JSON.parse(localStorage.getItem('ReceivableManagement'))
        ? JSON.parse(localStorage.getItem('ReceivableManagement'))
        : [
              { title: '费用状态', isShow: true, disabled: false },
              { title: '应收费用编号', isShow: true, disabled: false },
              { title: '费用类型', isShow: true, disabled: false },
              { title: '费用金额（元）', isShow: true, disabled: false },
              { title: '费用说明', isShow: true, disabled: false },
              { title: '装运单号', isShow: true, disabled: false },
              { title: '运单编号', isShow: true, disabled: false },
              { title: '子单号', isShow: true, disabled: false },
              { title: '原装运单号', isShow: true, disabled: false },
              { title: '交货单号', isShow: true, disabled: false },
              { title: '客户/基地名称', isShow: true, disabled: false },
              { title: '车队名称', isShow: true, disabled: false },
              { title: '收货地址', isShow: true, disabled: false },
              { title: '发货时间', isShow: true, disabled: false },
              { title: '送达时间', isShow: true, disabled: false },
              { title: '运单状态', isShow: true, disabled: false },
              { title: '回单状态', isShow: true, disabled: false },
          ];
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('ReceivableManagement', JSON.stringify(this.colData));
    }
    public searchFunc() {
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
        sessionStorage.setItem('ReceivableManagement_searchValue', JSON.stringify(this.searchValue));
    }
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
       public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'carrierOrderCode':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
            case 'realDeliveryTime':
                {
                    this.searchValue.orderBy = 2;
                }
                break;
            case 'realArrivalTime':
                {
                    this.searchValue.orderBy = 3;
                }
                break;
            case 'carrierOrderStatusStr':
                {
                    this.searchValue.orderBy = 4;
                }
                break;
        }
        this.loadData();
    }
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('ReceivableManagement_page', JSON.stringify(pagin));
        this.loadData();
    }
    public resetSearchValue() {
        this.searchValue = {
            status: '',
            carrierOrderCode: '',
            subOrderNo: '',
            shipOrderNo: '',
            originShipOrderNo: '',
            deliveryOrderNo: '',
            customerBaseName: '',
            customerBaseId:'',
            carrierName: '',
            startDeliveryTime: '',
            endDeliveryTime: '',
            expenseType: '',
            asc:true,
            orderBy:''
        };
        this.feeStatusList = [];
        this.timeList = [];
        this.searchFunc();
    }
    public async loadData() {
        this.loading = true;
        try {
          let skip = this.searchPagin.skip;
          let res = await ReceivableApi.GetList({
              ...this.searchValue,
              skip: skip,
              count: this.searchPagin.count
          });
          this.tableData = res.data;
          this.$refs.pagination.setPage(this.searchPagin.currentPage);
          this.tableData.map((item,index)=>{
              item.index = skip++ + 1;
          });
          this.total = res.total;
          this.loading = false;
            /**无数据返回上一页 */
          if (this.searchPagin.currentPage > 1) {
            if (this.tableData.length == 0) {
                this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
            }
          }
        } catch (error) {
          this.loading = false;
        }   
    }

    public datetimerange(v) {
        if (v) {
            this.searchValue.startDeliveryTime = v[0];
            this.searchValue.endDeliveryTime = v[1];
        } else {
            this.searchValue.startDeliveryTime = null;
            this.searchValue.endDeliveryTime = null;
        }
    }
    selectList = [];
    async querySearch1(queryString, cb) {
        let res = await yun.GetCarrierList({ Name: this.searchValue.carrierName, count: -1 });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }
    selectCar1(data) {
        this.searchValue.carrierName = data.value;
    }
    async querySearch(queryString, cb) {
        let res = await CustomerBase.GetDropDownList({ name: this.searchValue.customerBaseName});
        let result = [];
        res.forEach((dd) => {
            let xx = {
                value: dd.customerBaseName,
                id: dd.id,
            };
            result.push(xx);
        });
        cb(result);
    }
    selecShip(data) {
        this.searchValue.customerBaseName = data.value;
    }
    public async exportBtn() {
        let data = await ReceivableApi.GetListExport({
              ...this.searchValue,
              skip: this.searchPagin.skip,
              count: this.searchPagin.count
        });
    }

    public async GetfeeTypeList() {
        await ExpenseType.GetList({
            isEnable: true,
            skip: -1,
            count: -1,
        }).then((res) => {
            this.feeTypeList = res.data;
        });
    }
    public handleClose() {
        this.dialogVisible = false;
    }
    public carrierOrderCode: string = '';
    public toEdit(data){
        this.id = data.id;
        this.carrierOrderCode = data.carrierOrderCode;
        this.editForm = {
            expenseType:data.expenseType,
            amount:data.amount,
            expenseExplain: data.expenseExplain
        }
        this.dialogVisible = true;
    }

    public save() {
        this.$refs.editForm.validate(async (valid) =>{
            if(valid){
               ReceivableApi.Edit(this.id,this.editForm).then(res=>{
                        this.$message.success('编辑成功!');
                        this.loadData();
                        this.dialogVisible = false; 
               })
            }
        })
    }
    public getcarriageWayColor(val) {
        switch (val) {
            case '待派车':
                return 'c_agbr';
            case '待发货':
                return 'c_blue';
            case '在途中':
                return 'c_yellow';
            case '已送达':
                return 'c_green';
            case '已终结':
                return 'c_red';

            default:
                break;
        }
    }
public getReceiptColor(val) {
        switch (val) {
            case '回单未上传':
                return 'c_gray';
            case '回单已上传':
                return 'c_blue';
            case '回单已确认':
                return 'c_blue';
            case '回单已签收':
                return 'c_green';

            default:
                break;
        }
    }
    public getBillColor(val) {
        switch (val) {
            case 1:
                return 'c_blue';
            case 2:
                return 'c_yellow';
            case 3:
                return 'c_agbr';
            default:
                break;
        }
    }
   public feeStatusList = [];
    @Watch('feeStatusList')
    public feestatusListChange() {
        if (this.feeStatusList) {
            this.searchValue.status = this.feeStatusList.join(',');
        }
    }
  public toSkip(row, type) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    orderId: row.carrierOrderId,
                    type: 'fee',
                    fee: '2',
                },
            });
     
    }
   getShowData(data){
        let list = data.split(",");
        return list;
    }
}
